import { forwardRef } from "react";
import {
  revisionConflictNoticeModel,
  type RevisionConflictSection,
} from "../shared/waiting-pool-client";

export const RevisionConflictNotice = forwardRef<HTMLDivElement, {
  section: RevisionConflictSection;
  onDismiss: () => void;
}>(function RevisionConflictNotice({ section, onDismiss }, ref) {
  const model = revisionConflictNoticeModel(section);
  return <div className="revision-conflict-notice" role={model.role} tabIndex={model.tabIndex} ref={ref}>
    <h3>{model.title}</h3>
    <p>{model.message}</p>
    <button className="text-button" onClick={onDismiss} aria-label={model.dismissLabel}>
      关闭提示
    </button>
  </div>;
});
